import gql from 'graphql-tag';

const getVideoPublicLinkQuery = gql`
  query getVideoPublicLink($videoId: String!) {
    getVideoPublicLink(videoId: $videoId) {
      videoId
      link
      expiryDate
      password
    }
  }
`;

const getVideoPublicLink = () => ({
  query: getVideoPublicLinkQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: (videoId) => ({ videoId })
});

export default getVideoPublicLink;